import React from 'react';
import Card from 'react-bootstrap/Card'
import {ListGroup, ListGroupItem, Image} from 'react-bootstrap'
import bean from '../assets/coffeetable.svg'
import {Container} from 'react-bootstrap'
import {generateProfilePath} from '../../actions/actions'
import { NavLink } from 'react-router-dom'


const TableCuppingsCard = ({table, catadorId, isLoggedIn }) => {
  const srcId = generateProfilePath(catadorId)
  const monthFirstDate = `${table.date.substr(5)}-${table.date.substr(0, 4)}`
    return (
     <Container>
          <br></br><Card bg="white" text="black" className="card">
          <Card.Header className="tcard">
              <Image src={bean} alt="coffe_bean" className="beanSvg"/> <b style={{color: "chocolate", fontSize: "105%"}}>{monthFirstDate} </b> 
          </Card.Header>
          <Card.Body>
          <Card.Title>{table.name} <small style={{textAlign: "right", fontSize: "65%", color: "rgba(251, 77, 61, 1)", fontWeight: "bold"}}>{!table.public ? "- Private Cupping" : null}</small>
              {table.catador_name && catadorId ?  <p style={{fontSize: "79%"}}>by <b><NavLink to={`profile/${srcId}`} style={{color: "rgba(251, 77, 61, 1)", textDecoration: "none"}}> {table.catador_name.toUpperCase()} </NavLink></b></p>  : null}
          </Card.Title>
            <Card.Text>
              <i>{  table.description.length > 200 ? `${table.description.substring(0,200)}...(...)` : table.description}</i>
            </Card.Text>
            <ListGroup className="list-group-flush">
                  <ListGroupItem><span className="emoji" role="img" aria-label="coffee">☕️</span>Coffes Sampled: <b>{table.num_coffees}</b> </ListGroupItem>
              </ListGroup>
                <br></br>{isLoggedIn ? <NavLink style={{textDecoration: "none"}} className="outline-success" to={`/tables/${table.id}`}>Table Scores</NavLink> : <small><b>Please login to see scores.</b></small>} 
                &nbsp;&nbsp; 
          </Card.Body>
        </Card> &nbsp;&nbsp;  
      </Container>
    )
}

export default TableCuppingsCard